module.exports = __webpack_public_path__ + "img/header_img6.d5da2578.png";